export function isPriceValid(get: (path: string) => string | number): boolean {
    const sale = Number(get("transaction.sale.price"));
    const rent = Number(get("transaction.rental.monthlyRentalPrice"));
    return sale > 0 || rent > 0;
}
